<script >

import ContactStrip from "@/components/parts/ContactStrip.vue";

export default {
  components: {ContactStrip}
}
</script>

<template>
  <transition name="slide-fade" >
    <div style="min-height: 70vh">
      <div class="uk-padding ">
        <h1 class="uk-heading-line uk-text-center"><span> Board Governance & Support </span></h1>
        <div class="uk-container uk-container-small" id="strategic-planning">

          <h3 class="uk-heading-bullet  h2Style">Strategic Planning</h3>
          <p>
            The organization’s strategic plan is a key accountability and communication tool, as it sets the overall goals for the organization and an action plan to achieve them. It is a
            collaborative effort between management and the Board and is best accomplished via a facilitator that
            can invoke dialogue and analysis through thought provoking questions and different ways of
            accomplishing things. It is also important that this plan be developed with realistic timelines and sound
            budget projections with sufficient resources for it to be successful.
          </p>
          <p>
            Through our Board support process,
            FINCOR can help organizations navigate this crucial process and ensure a document that will
            communicate to the public, ministry, staff, and the CEO who will be accountable for its execution.
          </p>
        </div>
      </div>
      <div class="uk-padding uk-background-muted" id="ceo-performance-assessment">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">CEO Performance Assessment</h3>
          <p>
            The annual performance agreement between the Board and the Chief
            Executive Officer is a crucial governance tool. When properly prepared, it allows the Board to operate at
            the governance level while maintaining assurance that the goals, behaviours and policies of the
            organization are being effectively executed by the CEO. Under the Public Authorities Act, the Board can
            only dismiss the CEO or Managing Director for inadequate performance after evaluating two or more
            consecutive performance agreements.
          </p>
          <p>
            The performance agreement and assessment processes are
            therefore crucial to encourage expected behaviours and deter those the Board finds undesirable.
            FINCOR can help the Board draft performance agreements for its CEO and assist with the annual
            evaluation process by tracking agreed deliverables and reporting to the Board to enable objective
            assessments.
          </p>
        </div>
      </div>
      <div class="uk-padding " id="procurement-oversight">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Procurement oversight</h3>
          <p>
            There are no prescribed roles for the Board of Directors in the procurement
            process. Notwithstanding, the Board retains ultimate accountability for the decisions of the organization
            and has a duty to be informed. The Board’s implicit role is to ensure the procurement is carried out
            according to policies and procedures in a fair manner that delivers value for money to the organization.
            Many procurement processes have what is termed a “standstill period”. This is the period between the
            time a preferred bidder is identified and the time a contract is signed, it allows for questions to be asked
            and processes to be reviewed to ensure the decision was arrived in a fair manner.
          </p>
          <p>
            The Board does not
            question the decision, but it can question the process that was used to arrive at that decision and
            ensure relevant factors were considered, risks were appropriately mitigated, the organization is not
            committing itself beyond its fiscal limits, and there are no improprieties. FINCOR can provide expertise
            and insight at all stages of the procurement process, keep the Board apprised of progress and highlight
            any irregularities should those be detected.
          </p>
        </div>
      </div>
      <div class="uk-padding uk-background-muted" id="business-case-analysis">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Business Case analysis and support</h3>
          <p>
            The business case provides a justification for undertaking a project
            or programme and supports the decision making for investments. Business cases are statutorily required
            for projects with a value exceeding $100,000. The business case sets out the reason why change is
            necessary, looks at the objectives sought and the associated critical success factors, evaluates various
            options that could deliver those objectives, identifies a preferred option, and sets out a procurement
            strategy. Importantly, the document also considers the organization’s financial position, risks,
            constraints, and dependencies along with the resources that will be required by the project or
            programme and how those will impact the organization’s finances.
          </p>
          <p>
            Finally, it evaluates the
            organization’s capacity to implement the project, looks at the personnel impact, communication
            management, and governance arrangement. The Board can play a crucial role in this process by
            reviewing business cases, checking optimism biases, evaluating the risk management strategy, and
            considering where this fits within the organization’s strategic plan and priorities. An analysis of the
            business case will also inform the Board of what “done” means in relation to the project and serve as an
            accountability and evaluation tool to evaluate how well the project met the specified objectives and its
            execution within the resources of time and money. <br><br>FINCOR provides expert consulting services in the
            development of business cases and can provide support to the Board of Directors in analyzing those
            documents, meeting with drafters, devising questions and monitoring execution.
          </p>
        </div>
      </div>
      <div class="uk-padding " id="attend-board-and-committee-meetings">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Attend Board and Committee Meetings in a minute-taking and Advisory capacity</h3>
          <p>
            There is an
            increasing call for greater transparency in the operations of Boards as an accountability mechanism to
            the public on whose behalf the Board of Directors govern the organization. Appropriately capturing the
            key discussions and decisions at a Board meeting is an important pre-cursor to the improvement of this
            transparency through the publication of Board Minutes. The Board’s legacy will often be reposed in the
            series of records that are retained showing the decisions and discussions of the Board when the
            members held office. Having an experienced individual in the room that understand the key points to be
            captured, where motions are required, where a directive should be prepared and guiding the Board
            accordingly can be of significant benefit to Board members.
          </p>
          <p>
            At FINCOR we have over 15 years
            experience in the Boardroom of several organizations in various capacities. This experience creates a
            well-rounded understanding on how Boards function, the records to be kept and the way decisions are
            to be recorded. We also know many Boards waste 20 minutes of the meeting correcting
            minutes that have been poorly drafted or failed to capture key points. FINCOR can help with this by
            ensuring the Board operates efficiently, and the records are captured and held at the appropriate level.
          </p>
        </div>
      </div>
      <div class="uk-padding uk-background-muted">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Co-ordinate, produce and dispatch meeting agendas and board packs</h3>
          <p>
            With a properly functioning
            Board, the Chair meets with the CEO, discusses the agenda for the upcoming meeting, produce a draft
            agenda, circulates to members for input, approves the final agenda which is then sent back to the CEO
            to prepare papers, agendas, and reports. The timely production and circulation of these documents
            allows the board to function effectively and efficiently by focusing on important topics, having robust
            discourse and a healthy level of analysis.
          </p>
          <p>
            By outsourcing Board support to FINCOR, we can coordinate
            and facilitate the scheduling of these key processes and ensure the Board is provided with the materials
            necessary in a timely manner to have effective and efficient Board meetings.
          </p>
        </div>
      </div>
      <div class="uk-padding">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Set up and maintain the Board calendar, including reporting deadlines and meetings schedule</h3>
          <p>
            The Board has statutory responsibilities to ensure audited financials are provided to the Ministry within
            specified deadlines, members file declarations of interest, and the Authority complies with prescribed
            deadlines for budget submission, half-year reports and other requirements as stipulated by the Cabinet
            and or the relevant Minister from time to time.
          </p>
          <p>
            The Board will also want to ensure members are aware
            of meetings with sufficient notice to plan their calendars, or avoid
            periods of travel ahead of key decisions. FINCOR can help by collaboratively creating
            and managing the Board calendar to ensure the
            Board and its members comply with their respective responsibilities.
          </p>
        </div>
      </div>
      <div class="testStep">
        <div class="uk-padding uk-background-muted" style="background: rgba(0, 0, 0, 0.9)">
          <div class="uk-container uk-container-large">
            <div class="uk-child-width-1-2@l" uk-grid>
              <div>
                <h3 class="uk-heading-bullet h2Style">Hold statutory records</h3>
                <p>
                  The luxury of a private office for the Board is not always available, many
                  Authorities ask the CEO to hold the Board documents, but those documents may contain material and
                  information that is critical of the CEO. There is also no guarantee that records will not go missing over
                  time or fail to be transmitted from one Board to the next. FINCOR can provide secure storage for Board
                  Records with restricted access to personnel approved by the Board.
                </p>
              </div>
              <div>
                <h3 class="uk-heading-bullet h2Style">Guide the annual board evaluation process</h3>
                <p>
                  The Board has a statutory responsibility to periodically
                  assess its own performance. FINCOR can help by creating board evaluation templates, distributing for
                  self-assessments, and facilitating overall Board self-evaluation processes.

                </p>

              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="uk-padding uk-background-muted">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Advise on CIG corporate governance and industry best practice</h3>
          <p>
            The Board does not manage the
            organization, the Board ensures the organization is well managed. This is part science and part art, there
            is a fine line between effective governance and board overreach. A healthy relationship based on mutual
            respect and trust is possible; however, that relationship must be carefully managed with the Board using
            the tools legally at its disposal to discharge its functions … without inappropriately crossing into
            operational matters which are under the purview of the CEO.
          </p>
          <p>
            Years of experience in the Board room allows FINCOR a well rounded experience that
            benefit Boards in following best practices, overcoming
            hurdles and understanding the options legally available to achieve desired outcomes and policy
            objectives.
          </p>
          <router-link to="/blogs/board-governance"><span uk-icon="info" style="margin-right: 5px"></span>Click here to read our latest blog post on this topic</router-link>
        </div>
      </div>
      <div class="uk-padding">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Act as a central point of contact for the Board, other service providers and the central government</h3>
          <p>
            Board members often have busy private lives and spend only a few hours per month within the
            organization. Notwithstanding, employees, the ministry, oversight agencies and or external stakeholders
            may need to contact the Board office to make inquiries, schedule meetings, or convey messages.
          </p>
          <p>
            FINCOR can act as that central point of contact and convey messages to the Chair or members based on
            times and mediums that have been predetermined. This allows the Board to remain accessible without
            members having to be bombarded during their days with various calls and emails.
          </p>
        </div>
      </div>
      <div class="testStep">
        <div class="uk-padding uk-background-muted" style="background: rgba(0, 0, 0, 0.9)">
          <div class="uk-container uk-container-large">
            <div class="uk-child-width-1-2@l" uk-grid>
              <div>
                <h3 class="uk-heading-bullet h2Style">Manage the Annual report preparation and half year report</h3>
                <p>
                  FINCOR supports numerous government
                  agencies in the preparation of their annual reports. This includes drafting the message from the
                  Chairperson, summarizing the work of subcommittees during the year, comparing actual performance to
                  goals and objectives, and drafting forward looking statements. We can therefore support Boards with
                  reviewing and providing input for the annual reports produced by management and drafting appropriate
                  contributions from the perspective of the Board.
                </p>
              </div>
              <div>
                <h3 class="uk-heading-bullet h2Style">Create a code of conduct and Board communication policy</h3>
                <p>
                  Setting and managing expectations is key to
                  any relationship and crucial to successful governance. Tensions, role confusion and frustrations can build
                  when the Board communicates haphazardly, members break protocol, decisions are made informally
                  and via mediums such as WhatsApp. FINCOR can help the Board draft or review its code of conduct
                  manual and a Board communication policy document. This will set expectations for acceptable
                  behaviours and protocols and can be used as an accountability tool to bring members back onside if
                  divergence occurs.
                </p>

              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="uk-padding uk-background-muted">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Provide Board orientation and training for new members</h3>
          <p>
            We have witnessed many instances where
            individuals without prior governance or public sector experience have been appointed to Boards to
            govern multimillion dollar organization and the highly qualified people they employ. This can sometimes
            throw the organization into chaos as the Board member may seek to engage in matters which are
            inappropriate, fail to practice appropriate decorum, or downright act illegally through ignorance.
          </p>
          <p>
            They say the road to hell is paved with good intentions.
            Quite often, the failures of Boards are not due to
            malintent, it is a failure to undertake proper training, fully understand the functions of a Board member and
            the separation between the Executive and Non-Executive Directors. FINCOR can help by providing
            knowledge transfer, Board training and orientation and ongoing support to help new members to
            develop and mature while avoiding the pitfalls that can lead to waste, inefficiencies, and scandals.
          </p>
        </div>
      </div>
<!--      <div class="uk-padding">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Create a code of conduct and Board communication policy</h3>
          <p>
            Setting and managing expectations is key to
            any relationship and crucial to successfully governing. Tensions, role confusion and frustrations can build
            when the Board communicates haphazardly, members break protocol, decisions are made informally
            and via mediums such as WhatsApp.
          </p>
          <p>
            FINCOR can help the Board draft or review its code of conduct
            manual and a Board communication policy document. This will set expectations for acceptable
            behaviours and protocols and can be used as an accountability tool to bring members back onside if
            divergence occurs.
          </p>
        </div>
      </div>-->

      <ContactStrip />
    </div>
  </transition>
</template>

<style scoped>
.h2Style{
  font-family: 'Overlock SC';

}
.testStep{
  background-image: url('~@/assets/spreadsheet.jpg');
  background-size: cover;
}
.testStep *{
  color: silver;
}
</style>